// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"06cf0f84","453":"08def7b7"}[chunkId] + ".chunk.js";
};